// extracted by mini-css-extract-plugin
export default {"diet_list_table_container":"Diet-table-fc_diet_list_table_container__5uJZD"};